interface ITypeaheadOptions
{
	fitToElement?: boolean;
	displayText: ( item: any ) => string;
	afterSelect: ( item: any ) => void;
}

namespace ui
{
	export namespace Form
	{

		export interface ITypeaheadDescriptor extends IBasicInputDescriptor
		{
			displayText: ( item: any ) => string;
			afterSelect: ( item: any ) => void;
		}

		export class Typeahead<TITEM = any>
			extends BasicInputField<HTMLElement, ITypeaheadDescriptor>
		{

			public		Default: any;
			private		m_Item: TITEM|null;

			public constructor( descriptor: ITypeaheadDescriptor )
			{
				super( 'div', descriptor, InputValueTypes.ANY );

				this.m_Item		= null;
				this.Default	= null;
			}

			public Initialize(): void
			{
				super.Initialize();

				this.m_Root.addClass( 'typeahead' );
				this.m_Root.css( { 'height': 'auto', 'min-height': '34px'/*, "margin-left": "15px", "margin-right": "15px"*/ } );
				this.m_Root.attr( 'contenteditable', 'true' );
			}

			public Source( data: TITEM[] ): Typeahead<TITEM>
			{
				// @ts-ignore
				this.m_Root.typeahead(
					{
						afterSelect: ( item: TITEM|null ) => { this.Descriptor.afterSelect( item ); this.m_Item = item; },
						displayText: this.Descriptor.displayText,
						fitToElement: true,
						source: data
					}
				);

				return this;
			}

			public val(): TITEM|null
			{
				return this.m_Item;
			}

			public value( value: TITEM|null ): Typeahead<TITEM>
			{
				this.m_Item	= value;

				return this;
			}

			public reset(): Typeahead<TITEM>
			{
				this.value( this.Default );
				this.m_Root.html( '' );

				return this;
			}

		}

	}
}
